export const defaultAudioTracks = [
  {
    id: "audio-track-yong-yuan-bu-hui-tou",
    slug: "yong-yuan-bu-hui-tou",
    title: "永远不回头",
    artist: "特瑞饭",
    summary: "一首先放进声音留白里的示例歌曲。",
    date: "2026-04-22",
    duration: "音频作品",
    categorySlug: "music",
    categoryTitle: "音乐",
    audioUrl:
      "http://tdvlnk0fg.hd-bkt.clouddn.com/%E6%B0%B8%E8%BF%9C%E4%B8%8D%E5%9B%9E%E5%A4%B4_%E7%89%B9%E7%91%9E%E9%A5%AD.m4a",
    lyricsUrl: "",
  },
];
